var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { objectToTranslatableChoices } from '@shared/choice';
import { CLOSING_REASONS_LABELS } from '@backoffice/claim/claimClosingReasons';
import { INSURER_CONFIG } from '@shared/insurer';
let CloseClaimForm = class CloseClaimForm extends Vue {
    constructor() {
        super(...arguments);
        this.closingReason = null;
    }
    get closingReasonOptions() {
        return objectToTranslatableChoices(CLOSING_REASONS_LABELS).filter(({ value }) => { var _a, _b, _c; return (_c = (_b = (_a = INSURER_CONFIG.backoffice) === null || _a === void 0 ? void 0 : _a.supportedClosingReasons) === null || _b === void 0 ? void 0 : _b.includes(value)) !== null && _c !== void 0 ? _c : true; });
    }
    submit() {
        if (this.closingReason) {
            this.onConfirm(this.closingReason);
            this.$emit('close');
        }
    }
};
CloseClaimForm = __decorate([
    Component({
        props: {
            caseNumber: {
                type: String,
                required: true,
            },
            onConfirm: {
                type: Function,
                required: true,
            },
        },
    })
], CloseClaimForm);
export default CloseClaimForm;
